import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import SystemPreviewSection from "./components/SystemPreviewSection";
import CtaSection from "./components/CtaSection";
import useSEO from "@/hooks/useSEO";

const Home = () => {
  useSEO({
    title: "香港発・決済管理システム開発",
    description: "Stream Solutions Limitedは、銀行振込の決済管理・資金管理業務支援とシステム開発を提供する香港のフィンテック企業です。入金管理・消込処理・自動化システムで業務効率化を実現します。",
    keywords: "決済管理,資金管理,銀行振込,消込処理,フィンテック,システム開発,香港",
    canonical: "/",
    ogTitle: "Stream Solutions Limited | 銀行振込の管理を、もっと正確に、もっとシンプルに。",
    ogDescription: "決済管理・資金管理業務の支援とシステム開発により、業務の効率化と高度化を実現します。香港拠点のフィンテック企業。",
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <SystemPreviewSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
